import useThemeHotkey from '@cartwhl/common/hooks/useThemeHotkey';
import ActivateEarlyTrialModalHost from '@cartwhl/ui/modals/ActivateEarlyTrialModalHost';
import PurchaseCreditsModalHost from '@cartwhl/ui/modals/PurchaseCreditsModalHost';

import Layout from '../components/Layout';
import Notices from '../components/Notices';
import ScrollToTop from '../components/ScrollToTop';
import { ModalManager } from '../modals';

export default function PublicLayoutRoute() {
  useThemeHotkey({ persist: false });

  return (
    <>
      <ScrollToTop />
      <Notices />
      <ModalManager />
      <PurchaseCreditsModalHost />
      <ActivateEarlyTrialModalHost />
      <Layout />
    </>
  );
}
